const IframeController = require('../../../utils/IframeController')(true);

module.exports = () => {
  // Full size
  IframeController.resize(3000);
};
